import { Outlet } from 'react-router-dom';
import { Layout } from 'tdesign-react';

import Auth403 from '@/pages/error/403';
import { useTypedSelector } from '@/store';

const { Content } = Layout;

const DocLayout = () => {
  const { hasAVGAuth, noUgcAuth } = useTypedSelector(store => store.auth);

  if (!hasAVGAuth || noUgcAuth) {
    return <Auth403 />;
  }

  return (
    <Layout className="nova-root">
      <Content className="nova-content">
        <Outlet
          context={{}} />
      </Content>
    </Layout >
  );
};

export default DocLayout;
